import { createContext } from 'react'

export const AllCoursesContext = createContext({})

AllCoursesContext.displayName = 'AllCoursesContext'
